(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circle_shaped_banners"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    // Get the container element
    var container = document.querySelector('.circle-shaped-banners-container');
    
    // Check if the container exists
    if (container) {
      // Calculate total width of all banners
      var totalWidth = 0;
      var banners = container.querySelectorAll('div');
      
      banners.forEach(function(banner) {
        totalWidth += banner.offsetWidth + parseInt(getComputedStyle(banner).marginRight);
      });
      
      // Set the width of the container to accommodate all banners
      container.style.width = totalWidth + 'px';
    }
  });


  } catch(e) { console.error(e); }
})();
})();
